import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron up small.svg` */
export const ChevronUpSmallIcon = createTripletGlyphIcon('ChevronUpSmallIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4023 10.1601C12.5938 10.3955 12.5584 10.7417 12.3232 10.9336C12.0877 11.1254 11.7407 11.09 11.5488 10.8545L7.86909 6.33689L4.46284 10.8388C4.27959 11.081 3.93456 11.1294 3.69233 10.9463C3.45011 10.763 3.40265 10.418 3.58589 10.1758L7.35835 5.18943C7.60175 4.86773 8.08204 4.85912 8.33686 5.17185L12.4023 10.1601Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1472 12.0929C15.3909 12.3926 15.346 12.8332 15.0466 13.0773C14.747 13.3213 14.3054 13.2762 14.0613 12.9767L8.81322 6.53435L3.95384 12.9572C3.72058 13.2652 3.28157 13.3259 2.97337 13.0929C2.66516 12.8598 2.60461 12.4208 2.83763 12.1125L8.15599 5.08318C8.46965 4.66866 9.08837 4.65773 9.41673 5.06072L15.1472 12.0929Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.213 16.144C20.5269 16.5292 20.4691 17.0966 20.0841 17.4106C19.6989 17.7244 19.1325 17.6667 18.8185 17.2817L15.3058 12.9702L11.7931 8.65864L5.28819 17.2563C4.98825 17.6524 4.42372 17.7308 4.02745 17.4311C3.63123 17.1313 3.55316 16.5667 3.85265 16.1704L10.9444 6.79732C11.3497 6.26234 12.1493 6.24775 12.5733 6.76802L20.213 16.144Z"
        fill="currentColor"
      />
    </svg>
  ),
});
